export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const LOGIN = 'LOGIN';
export const IS_LOADING = 'IS_LOADING';
export const CHECK_ROUTE = 'CHECK_ROUTE';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const GENERATE_PASSWORD = 'GENERATE_PASSWORD';
export const SYNC_FAULT_MAP_WITH_TABLE = 'SYNC_FAULT_MAP_WITH_TABLE';
export const SYNC_ASSET_HEALTH_MAP_WITH_TABLE =
  'SYNC_ASSET_HEALTH_MAP_WITH_TABLE';
export const SYNC_ENERGY_EFFICIENCY_MAP_WITH_TABLE =
  'SYNC_ENERGY_EFFICIENCY_MAP_WITH_TABLE';

export const HIDE_SHOW_NOTES = 'HIDE_SHOW_NOTES';
export const CONFIGURE = 'CONFIGURE';

export const SHOW_HELPBOX = 'SHOW_HELPBOX';
export const HIDE_HELPBOX = 'HIDE_HELPBOX';

export const SHOW_FAULT_EXPORT_DATA = 'SHOW_FAULT_EXPORT_DATA';
export const HIDE_FAULT_EXPORT_DATA = 'HIDE_FAULT_EXPORT_DATA';

export const GET_PERFORMANCE_ALERTS = 'GET_PERFORMANCE_ALERTS';
export const GET_PERFORMANCE_TRACKERS = 'GET_PERFORMANCE_TRACKERS';

export const GET_NOTES_BY_ALERTID_AND_ALERTTYPE =
  'GET_NOTES_BY_ALERTID_AND_ALERTTYPE';
export const SAVE_NOTES = 'SAVE_NOTES';

export const GET_DIVISION = 'GET_DIVISION';
export const GET_PRIMARY_NODE = 'GET_PRIMARY_NODE';
export const GET_LOCATION_BY_DIVISION = 'GET_LOCATION_BY_DIVISION';
export const GET_FEEDERS_LOCATION = 'GET_FEEDERS_LOCATION';
export const GET_VOLTAGE_CHARTS = 'GET_VOLTAGE_CHARTS';
export const GET_RELIABILITY_CHARTS = 'GET_RELIABILITY_CHARTS';
export const GET_PHASOR_CHARTS = 'GET_PHASOR_CHARTS';
export const GET_PHASOR_INSTANTANEOUS_DATA = 'GET_PHASOR_INSTANTANEOUS_DATA';
export const GET_DEMAND_CHARTS = 'GET_DEMAND_CHARTS';
export const GET_FREQUENCY_CHARTS = 'GET_ENERGY_CHARTS';
export const GET_PEAK_DEMAND_PROFILES = 'GET_PEAK_DEMAND_PROFILES';
export const GET_PERFORMANCE_ALERTS_CHIELD = 'GET_PERFORMANCE_ALERTS_CHIELD';

export const MOVE_TO_HISTORIC = 'MOVE_TO_HISTORIC';
export const MOVE_TO_ARCHIVE = 'MOVE_TO_ARCHIVE';
export const GET_DETAILS_BY_ALERT_ID = 'GET_DETAILS_BY_ALERT_ID';
export const PASS_ALERTS_DATA = 'PASS_ALERTS_DATA';

export const GET_TABLE_OF_FAULTS = 'GET_TABLE_OF_FAULTS';

export const GET_SLD_DATA = 'GET_SLD_DATA';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_DAILY_REPORT_BY_DATE_AND_ID =
  'GET_DAILY_REPORT_BY_DATE_AND_ID';
export const SYNC_NODE_WITH_DDL = 'SYNC_NODE_WITH_DDL';
export const SYNC_SLD_OBJ = 'SYNC_SLD_OBJ';

export const SET_LEVEL_INFO = 'SET_LEVEL_INFO';
export const SET_UNITS = 'SET_UNITS';
